var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8875 3.92501C24.6975 3.8153 24.4819 3.75755 24.2625 3.75755C24.0431 3.75755 23.8275 3.8153 23.6375 3.92501L13 9.82501L2.3625 3.91251C2.17245 3.80569 1.95776 3.75042 1.73975 3.75221C1.52174 3.754 1.30798 3.81277 1.11971 3.92271C0.931434 4.03264 0.775186 4.1899 0.666477 4.37888C0.557767 4.56787 0.500375 4.78199 0.5 5.00001V17.5C0.5 18.163 0.763392 18.7989 1.23223 19.2678C1.70107 19.7366 2.33696 20 3 20H23C23.663 20 24.2989 19.7366 24.7677 19.2678C25.2366 18.7989 25.5 18.163 25.5 17.5V5.00001C25.4999 4.78308 25.4434 4.5699 25.3361 4.38142C25.2287 4.19294 25.0741 4.03565 24.8875 3.92501Z",
    fill: "#0057FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9995 0H2.99955C2.33651 0 1.70063 0.263392 1.23179 0.732232C0.762946 1.20107 0.499554 1.83696 0.499554 2.5V4.99999C0.497708 5.22361 0.555881 5.44362 0.668009 5.6371C0.780138 5.83057 0.942115 5.99043 1.13705 6.09999L12.387 12.35C12.5793 12.4528 12.794 12.5067 13.012 12.5067C13.2301 12.5067 13.4448 12.4528 13.637 12.35L24.887 6.09999C25.0773 5.98723 25.2343 5.82599 25.3419 5.63274C25.4495 5.43949 25.5039 5.22114 25.4995 4.99999V2.5C25.4995 1.83696 25.2361 1.20107 24.7673 0.732232C24.2985 0.263392 23.6626 0 22.9995 0Z",
    fill: "#E1EAFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.84b4a276.svg";
export { ForwardRef as ReactComponent };